var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 153,
    viewBox: "0 0 1920 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #ff5858;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #ff5858;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M0,218H1920V31S1440.17,151,960,151C480.167,151,0,31,0,31V218Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Curve_Line_1",
    "data-name": "Curve Line 1",
    className: "cls-2",
    d: "M0,81s379.833,50,860,50c479.83,0,1060-100,1060-100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Curve_Line_2",
    "data-name": "Curve Line 2",
    className: "cls-3",
    d: "M0,1S479.833,151,960,151c479.83,0,960-70,960-70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBottom);
export default __webpack_public_path__ + "static/media/hero-bottom.c2569e7c0c3eb746e04a96e0a2f4bdaf.svg";
export { ForwardRef as ReactComponent };